<template>
  <div class="box">
    <img class="bg-img-one" />
    <img class="bg-img-two" />
    <div class="wrapper-main">
      <!-- <div class="banner-box"></div> -->


      <div class="wrapper-content">
        <sticky>
          <!-- <div style="background: #FAFAFA; ">
          <h1 style="margin: 0; line-height: 1.5">二级路由演示</h1>
          <router-link to="/product/list">ListPage</router-link>
          <router-link to="/product/edit">EditPage</router-link>
        </div> -->
        </sticky>
        <keep-alive>
          <router-view></router-view>
        </keep-alive>
      </div>
    </div>
  </div>
</template>

<script>
import Sticky from '@/components/Sticky'
export default {
  name: 'Product',
  components: { Sticky },
  data() {
    return {

    }
  }
}
</script>

<style scoped type="text/less" lang="less">
@import "../../assets/css/product.less";

.box {
  text-align: center;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}

.bg-img-one {
  width: 100%;
  height: 1600px;
  background: url(../../assets/img/product-01.jpg) no-repeat center center;
  background-size: 80%;
}

.bg-img-two {
  width: 100%;
  height: 1300px;
  background: url(../../assets/img/product-02.jpg) no-repeat center center;
  background-size: 80%;
}
</style>
